import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import ResourceSurvey from './ResourceSurvey';
import SurveyPage2 from './SurveyPage2';
import SurveyPage3 from './SurveyPage3';
import EndSurvey from './EndSurvey';

const SurveyContainer = () => {
  // Central state to hold all survey data
  const [surveyData, setSurveyData] = useState({});

  // Function to update survey data
  const updateSurveyData = (newData) => {
    setSurveyData((prevData) => ({
      ...prevData,
      ...newData
    }));
  };

  // Function to handle form submission
  const handleSubmit = () => {
    console.log('Final Survey Data:', surveyData);
    alert('Survey Submitted! Check console for data.');
    // You can also make an API call here to submit the data
  };

  return (
    <div>
      <Routes>
        <Route 
          path="/survey" 
          element={<ResourceSurvey surveyData={surveyData} setSurveyData={updateSurveyData} />} 
        />
        <Route 
          path="/surveypage2" 
          element={<SurveyPage2 surveyData={surveyData} setSurveyData={updateSurveyData} />} 
        />
        <Route 
          path="/surveypage3" 
          element={<SurveyPage3 surveyData={surveyData} setSurveyData={updateSurveyData} />} 
        />
        <Route 
          path="/endpage" 
          element={<EndSurvey/>} 
        />
      </Routes>
    </div>
  );
};

export default SurveyContainer;
